import { HTTPRequestMethod } from 'lib-shared-legacy-types';

import { ContentType } from 'components/powerFlowShared/components/types';

export const HTMLRequestTypes = [
  { id: HTTPRequestMethod.Get, name: 'GET' },
  { id: HTTPRequestMethod.Post, name: 'POST' },
  { id: HTTPRequestMethod.Put, name: 'PUT' },
  { id: HTTPRequestMethod.Delete, name: 'DELETE' },
  { id: HTTPRequestMethod.Patch, name: 'PATCH' },
];

export const contentTypes = [
  {
    id: ContentType.APPLICATION_JSON,
    name: 'Application/json',
  },
  {
    id: ContentType.APPLICATION_JAVASCRIPT,
    name: 'Application/javascript',
  },
  {
    id: ContentType.APPLICATION_XML,
    name: 'Application/xml',
  },
  { id: ContentType.TEXT_PLAIN, name: 'Text/plain' },
  {
    id: ContentType.TEXT_JAVASCRIPT,
    name: 'Text/javascript',
  },
  { id: ContentType.TEXT_XML, name: 'Text/xml' },
  { id: ContentType.TEXT_HTML, name: 'Text/html' },
  { id: ContentType.TEXT_CSV, name: 'Text/csv' },
];

export const tabs = [
  {
    id: 'headers',
    label: 'Headers',
  },
  {
    id: 'body',
    label: 'Body',
  },
  {
    id: 'test',
    label: 'Test',
  },
];
